import * as React from 'react';

export const Hamburger = ({ onClick }) => {
  return (
    <svg
      onClickCapture={onClick}
      className='top-bar-hamburger'
      width='24'
      height='20'
      viewBox='0 0 24 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M24 9H0V11H24V9Z' fill='white' />
      <path d='M24 18H0V20H24V18Z' fill='white' />
      <path d='M24 0H0V2H24V0Z' fill='white' />
    </svg>
  );
};
